import { AdminService } from './admin.service';

export const services = [
  AdminService,
];
